import React from 'react';

import { PreloaderSpinnerProps } from './PreloaderSpinner';

export type PreloaderContextProps = {
  isLoading: boolean;
  fullScreenImage: boolean;
  isTapToPlayVisible: boolean;
  playLabel: string;
  showFooter: boolean;
  show: boolean;
  spinner?: React.FC<PreloaderSpinnerProps>;
  onDestroy: (e: TransitionEvent) => void;
}

export const PreloaderContext = React.createContext<PreloaderContextProps>({
  isLoading: true,
  fullScreenImage: false,
  playLabel: '',
  showFooter: false,
  isTapToPlayVisible: true,
  spinner: undefined,
  show: false,
  onDestroy: () => {},
});
